const { Modal } = require("antd");

export const ModalErro = (titulo = 'Erro inesperado', erros = 'Por favor tente novamente ou contate nosso suporte.') => {
    let mensagem = erros;
    if (Array.isArray(erros)) {
        mensagem = erros.map(erro => <p>{erro}</p>);
    }

    Modal.error({
        title: titulo,
        content: mensagem,
        centered: true,
        style: { whiteSpace: 'pre-line' },
        width: 600,
    });
};

export function ModalErroBotoesCustomizados({
    titulo,
    conteudo,
    onClickAcao,
    labelBotaoOk,
    largura = 600,
    centralizado = true,
}) {
    Modal.error({
        title: titulo,
        width: largura,
        content: conteudo,
        okText: labelBotaoOk,
        onOk: async () => {
            if (onClickAcao) {
                await onClickAcao();
            }
        },
        centered: centralizado,
    });
}